import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "version-copyright-section" }
const _hoisted_2 = { class: "version-copyright-group" }
const _hoisted_3 = { class: "version-copyright-sdk" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "version-copyright-center-line" }, null, -1)
const _hoisted_5 = { class: "version-copyright-year" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "cookie-consent-settings",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.settingCookies()))
        }, "การตั้งค่าคุกกี้"),
        _hoisted_4,
        _createElementVNode("span", null, "เวอร์ชั่น " + _toDisplayString(_ctx.version) + " (" + _toDisplayString(_ctx.charCodeGithush) + ")", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, "ลิขสิทธิ์ของบริษัท ซีพี แอ็กซ์ตร้า จำกัด (มหาชน) " + _toDisplayString(_ctx.yearCopyRight), 1)
      ])
    ])
  ]))
}